export default __webpack_public_path__ + "static/media/icon-tea-cup.f220adcc.svg";